import React, { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import style from "css/template.module.css";
import Sitemap from "./sitemap";
import { useMediaQuery } from "react-responsive";
import TermsModal from "components/common/termsModal";
import PRIVACY_POLICY from "components/common/docs/privacyPolicyDoc";

/**
 * Version : 1.0
 * 작성일자 : 2025-02-10
 * 작성자 : 강연승
 * 설명 : footer
 */

function Footer() {
  //반응형
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  // const check = useMediaQuery({ query: "(max-width: 1024px)" });

  const [openDoc, setOpenDoc] = useState(null);
  const closeDoc = useCallback(() => setOpenDoc(null), []);

  return (
    <>
      <div className={style.footer}>
        {!isMobile && !isTablet ? <Sitemap /> : <></>}

        <div className={style.company_wrap}>
          <img
            src={`${process.env.REACT_APP_CLIENT_URL}img/common/logo3x.webp`}
            alt="logo"
            style={{ width: "137px", height: "auto" }}
          />
          <div className={style.company_info_area}>
            <div className={style.company_info}>
              <div>
                Add : 경기도 안양시 동안구 시민대로 327번길 11-41, 514호
                (관양동)
              </div>
              {!isMobile && !isTablet ? (
                <div>
                  <a href="tel:070-7798-1311">Tel : 070-7798-1311</a> | Email :
                  support@riv-tech.co.kr
                </div>
              ) : (
                <>
                  <div>
                    <a href="tel:070-7798-1311">Tel : 070-7798-1311</a> | <br />
                    Email : support@riv-tech.co.kr
                  </div>
                </>
              )}
            </div>
            <div className={style.company_policy}>
              <button
                type="button"
                className={style.company_policy_item}
                onClick={() => setOpenDoc(PRIVACY_POLICY)}
              >
                개인정보처리방침
              </button>
              {/* 연결할 문서가 준비되면 해제
              <Link className={style.company_policy_item}>
                Terms of Service
              </Link>
              <Link className={style.company_policy_item}>Cookie Policy</Link>
              */}
            </div>
          </div>
        </div>
        <div className={style.copyright}>
          @2024 RivTechnology. All rights reserved.
        </div>
      </div>

      <TermsModal
        open={Boolean(openDoc)}
        doc={openDoc}
        onClose={closeDoc}
      />
    </>
  );
}

export default Footer;
